import { Modal, useModals } from 'almanac-ui/Modal'
import { useState } from 'react'
import { Property } from 'api/clients/PropertyClient'
import { pluralize } from 'utils'
import Styles from './ConfirmModal.module.scss'
import { TreeFilesView } from 'screens/Finder/FinderContextTypes'
import { Calendar } from 'almanac-ui/icons/16'

type Props = {
  filesView?: TreeFilesView
  property?: Property
  onConfirm: () => void
}

export const ConfirmModal = ({ filesView, property, onConfirm }: Props) => {
  const [isConfirming, setIsConfirming] = useState(false)
  const { closeModal } = useModals()
  const dependantViews = filesView?.all_schemas.filter((s) => s.calendar_property_id === property?.id) || []
  const multipleViews = dependantViews.length > 1

  const view = pluralize('View', dependantViews.length)
  const thisOrThese = multipleViews ? 'these' : 'this'
  const itsOrTheir = multipleViews ? 'their' : 'its'
  const confirmButton = multipleViews ? `Delete Property & Calendar ${view}` : 'Delete Property'
  const body =
    dependantViews.length > 0 ? (
      <>
        <p>{`Deleting this property will also delete the below Calendar ${view} which use this property. If you would like to
        avoid losing ${thisOrThese} ${view}, modify ${itsOrTheir} Date property to an alternative`}</p>
        <div className={Styles.views}>
          <div className={Styles.label}>Calendar Views</div>
          {dependantViews.map((view) => (
            <div className={Styles.view} key={view.id}>
              <div className={Styles.name}>
                <Calendar />
                <span>{view.name}</span>
              </div>
              <div className={Styles.creator}>created by {view.creator}</div>
            </div>
          ))}
        </div>
      </>
    ) : (
      'Deleting this property will delete it everywhere.'
    )

  const confirmDeleteProperty = async () => {
    setIsConfirming(true)
    await onConfirm()
    setIsConfirming(false)
  }

  return (
    <Modal.Root>
      <Modal.Header title="Delete Property?" />
      <Modal.Content>
        <div>{body}</div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" size="lg" onPress={closeModal}>
            Cancel
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Modal.FooterButton variant="primary" size="lg" onPress={confirmDeleteProperty} isDisabled={isConfirming}>
            {confirmButton}
          </Modal.FooterButton>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
